import { render, staticRenderFns } from "./SectorChart.vue?vue&type=template&id=498f884d"
import script from "./SectorChart.vue?vue&type=script&lang=js"
export * from "./SectorChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports